<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div aria-describedby="modalDescription"
           aria-labelledby="modalTitle"
           class="modal modal-custom-text"
           role="dialog"
      >
        <header
            id="modalTitle"
            class="modal-header"
        >
          <slot name="header">
            Êtes-vous sûr(e) ?
          </slot>
        </header>

        <section
            id="modalDescription"
            class="modal-body"
        >
          <slot name="body">
            Vos réponses ont été enregistrées.<br> Vous êtes sur le point de valider le questionnaire.<br><br>
            Il ne vous sera plus possible plus de vous reconnecter et de modifier vos réponses.<br><br>
            Souhaitez-vous valider vos réponses ?
          </slot>
        </section>

        <footer class="modal-footer">
          <button
              aria-label="Close modal"
              class="btn"
              type="button"
              @click="emit('finish')"
          >
            Valider
          </button>
          <button
              aria-label="Close modal"
              class="btn"
              type="button"
              @click="emit('close')"
          >
            Annuler
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script setup>
const emit = defineEmits(['close', 'finish']);
</script>
